import React, { memo } from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../Button/index'
import ChevronLeft from '../../../../Icon/icons/ChevronLeft/index'
import CarouselDots from '../../../shared/CarouselDots/index'

/**
 * Back + Primary buttons + CarouselDots block rendered at the bottom of
 * each smart-step.
 */
export interface SmartFooterProps {
  backLabel: string
  primaryLabel: string
  onBack: () => void
  onPrimary: () => void
  isPrimaryDisabled: boolean
  isFirstSmartStep: boolean
  totalDots: number
  activeDot: number
}

function SmartFooterBase ({
  backLabel,
  primaryLabel,
  onBack,
  onPrimary,
  isPrimaryDisabled,
  isFirstSmartStep,
  totalDots,
  activeDot,
}: SmartFooterProps) {
  return (
    <div className="create-playlist-modal__smart-footer">
      <div className="create-playlist-modal__smart-footer-buttons">
        {isFirstSmartStep ? (
          <span />
        ) : (
          <Button
            type={BUTTON_TYPES.GHOST}
            className="create-playlist-modal__smart-back-btn"
            onClick={onBack}
          >
            <ChevronLeft />
            {backLabel}
          </Button>
        )}
        <Button
          type={BUTTON_TYPES.PRIMARY}
          className="create-playlist-modal__smart-primary-btn"
          onClick={onPrimary}
          disabled={isPrimaryDisabled}
        >
          {primaryLabel}
        </Button>
      </div>
      <CarouselDots
        total={totalDots}
        current={activeDot}
        className="create-playlist-modal__smart-dots"
      />
    </div>
  )
}

const SmartFooter = memo(SmartFooterBase)
SmartFooter.displayName = 'SmartFooter'
export default SmartFooter
